import { SkeletonText } from 'reference-resolvers-lite/components/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingValue = () => /*#__PURE__*/_jsx("span", {
  className: "loading",
  "data-selenium-test": "formatted-property-value-loading-value",
  "data-test-id": "formatted-property-value-loading-value",
  children: /*#__PURE__*/_jsx(SkeletonText, {})
});
export default LoadingValue;